__webpack_require__.p = "/custom-brand-color/referrals-hub/";